import _styled, { css as _css, default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12 } from "styled-components";
import { Wrap } from "~/features/ui/wrap";
import { Headline } from "~/features/ui/headline";
import { Media } from "~/features/ui/media";
import { takeFirst } from "~/features/app/utils";
import { Section, CardProgressBar } from "../partner-gallery/shared";
import { usePartnerGallery } from "../partner-gallery/use-partner-gallery";
import { CoreVideoFeaturesGalleryControls } from "./controls";
import { type CoreVideoFeaturesGalleryLayoutProps } from "./shared";
export function CoreVideoFeaturesGalleryDesktopView({
  items,
  hasTopDivider,
  anchor,
  headline,
  sectionProps
}: CoreVideoFeaturesGalleryLayoutProps) {
  const {
    activeIndex,
    cardContentRef,
    mediaContainerRef,
    changeSlide,
    handleAutoAdvance
  } = usePartnerGallery(items.length);
  const activeItem = items[activeIndex];
  const anchorItem = takeFirst(anchor);
  return <_StyledSection {...sectionProps} data-theme="light" id={anchorItem?.id || undefined} data-anchor-name={anchorItem?.name || undefined} $_css2={[{
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block"
    }
  }, {
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  }]}>
      <_StyledWrap>
        <_StyledDiv $_css3={[{
        "padding": "var(--spacing-xl)"
      }, hasTopDivider && {
        "borderTopWidth": "1px",
        "borderColor": "var(--stroke-primary)"
      }]}>
          {headline && <_StyledHeadline type="h2" text={headline} />}
          <_StyledDiv2 ref={mediaContainerRef} $_css4={[{
          "position": "relative",
          "aspectRatio": "1520/725",
          "overflow": "hidden",
          "borderRadius": "4px",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(69 69 69 / var(--tw-bg-opacity))"
        }]}>
            {items.map((item, idx) => {
            const media = item.media;
            return <_StyledDiv3 key={idx} data-media-idx={idx} style={{
              opacity: idx === activeIndex ? 1 : 0,
              transition: "opacity 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
            }} $_css5={[{
              "position": "absolute",
              "inset": "0",
              "overflow": "hidden"
            }]}>
                  {media && <_StyledDiv4 data-zoom $_css6={[{
                "height": "100%",
                "width": "100%"
              }, _css(["& img,& video{object-fit:contain !important;}& mux-player{--media-object-fit:contain !important;}"])]}>
                      <Media {...media} imageProps={{
                  fit: "cover",
                  rounded: false,
                  loading: idx === 0 ? "eager" : "lazy"
                }} inlineVideoProps={{
                  fit: "cover",
                  rounded: false
                }} externalVideoProps={{
                  fit: "cover"
                }} />
                    </_StyledDiv4>}
                </_StyledDiv3>;
          })}
          </_StyledDiv2>

          <_StyledDiv5 ref={cardContentRef} $_css7={[{
          "display": "flex",
          "alignItems": "flex-start",
          "justifyContent": "space-between",
          "gap": "var(--spacing-xl)",
          "paddingTop": "var(--spacing-xl)"
        }]}>
            <_StyledDiv6>
              <CardProgressBar key={activeIndex} onComplete={handleAutoAdvance} />
            </_StyledDiv6>

            <_StyledDiv7 key={activeIndex} $_css8={[{
            "display": "flex",
            "maxWidth": "48rem",
            "flexDirection": "column",
            "gap": "var(--spacing-xs)"
          }]}>
              {activeItem?.headline && <div data-animate="title">
                  <_StyledHeadline2 type="h4" text={activeItem.headline} />
                </div>}
              {activeItem?.description && <_StyledDiv8 data-animate="description">
                  {activeItem.description}
                </_StyledDiv8>}
            </_StyledDiv7>

            <CoreVideoFeaturesGalleryControls items={items} activeIndex={activeIndex} onSelect={changeSlide} />
          </_StyledDiv5>
        </_StyledDiv>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled(Section).withConfig({
  componentId: "sc-sf-c3zygu-0"
})`${p => p.$_css2}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-c3zygu-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv = _styled3("div").withConfig({
  componentId: "sc-sf-c3zygu-2"
})`${p => p.$_css3}`;
var _StyledHeadline = _styled4(Headline).withConfig({
  componentId: "sc-sf-c3zygu-3"
})({
  "paddingBottom": "var(--spacing-xl)",
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv2 = _styled5("div").withConfig({
  componentId: "sc-sf-c3zygu-4"
})`${p => p.$_css4}`;
var _StyledDiv3 = _styled6("div").withConfig({
  componentId: "sc-sf-c3zygu-5"
})`${p => p.$_css5}`;
var _StyledDiv4 = _styled7("div").withConfig({
  componentId: "sc-sf-c3zygu-6"
})`${p => p.$_css6}`;
var _StyledDiv5 = _styled8("div").withConfig({
  componentId: "sc-sf-c3zygu-7"
})`${p => p.$_css7}`;
var _StyledDiv6 = _styled9("div").withConfig({
  componentId: "sc-sf-c3zygu-8"
})({
  "visibility": "hidden",
  "position": "absolute"
});
var _StyledDiv7 = _styled10("div").withConfig({
  componentId: "sc-sf-c3zygu-9"
})`${p => p.$_css8}`;
var _StyledHeadline2 = _styled11(Headline).withConfig({
  componentId: "sc-sf-c3zygu-10"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "opacity": "0.5",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});
var _StyledDiv8 = /*#__PURE__*/_styled12("div").withConfig({
  displayName: "desktop___StyledDiv8",
  componentId: "sc-o7188p-0"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.8rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.018rem",
    "fontWeight": "400"
  }
});